import React, { useState, useEffect } from 'react';
import PropTypes  from 'prop-types';
import Helmet from 'react-helmet';
import get from 'lodash/get'
import axios from 'axios';
import { Row, Col, Button } from 'reactstrap'
import { TextField } from '@material-ui/core/'
import { Field, reduxForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';
import { promptUser } from '../../../../redux/actions/notificationsActions';

// Libs
import { validateRfc } from '../../../../libs/utils'

// Img
import { SAT_IMG } from '../../../../constants/assets';

// endpoints
import { VALIDATION_RFC } from '../../../../constants/endpoints';

const renderTextField = ({ input = {}, label, meta: { touched, error }, type, InputProps, disabled }) => (
  <div className='material-form__field-wrapper'>
    <TextField
			id={input.name}
      className='material-form__field'
      variant="outlined"
      label={label}
      error={touched && !!error}
      type={type}
      value={input.value}
      onChange={(e) => {
        e.preventDefault();
        input.onChange(e.target.value);
      }}
      disabled={ disabled }
      InputProps={ InputProps }
      autoComplete="off"
    />
    { touched && error && <span className='form__form-group-error'>{ error }</span> }
  </div>
); // END renderTextField

const FormSatRfc = (props) => {
  const [disabled, setDisabled] = useState(false);
  const [rfc, setRfc] = useState(null);

  useEffect(() => {
    setDisabled(!!get(props, 'integrations.sat.is_enabled') || !!get(props, 'integrations.sat_downloads.is_enabled'))
    takeRfc()
    props.initialize({
      'sat_rfc': rfc
    })
  }, [rfc])

  const takeRfc = () => {
    if(get(props, 'rfc')) {
      setRfc(get(props, 'rfc'))
    } else if(get(props, 'integrations.sat.sat_rfc')) {
      setRfc(get(props, 'integrations.sat.sat_rfc'))
    } else {
      setRfc(get(props, 'integrations.sat_downloads.sat_rfc'))
    }

  } // END takeRfc

  const onSubmit = (form) => {
    axios.post(VALIDATION_RFC, form)
      .then(res => {
        if(get(res, 'status') === 200) {
          props.setGlobalRfc(form.sat_rfc)
          props.setPage(2)
        }
      })
      .catch(e => console.error(e))
  }

  return (
    <div className="sat__integration">
      <Helmet>
        <script src="//embed.typeform.com/next/embed.js"></script>
      </Helmet>
      <Row className="row__info">
        <Col xs={2}>
          <img src={ SAT_IMG } alt="SAT_logo"/>
        </Col>
        <Col>
          <p>Bienvenido a la la integración con el Sistema de Administración Tributaria SAT, para que puedas descargar automáticamente tus facturas y poder emitir tus timbres o firmar tus facturas con tus certificados.</p>
        </Col>
      </Row>
      <form className='material-form stripe' onSubmit={ props.handleSubmit(onSubmit) }>
        <Row>
          <Col>
            <Field
              name="sat_rfc"
              component={ renderTextField }
              label="RFC"
              disabled={ disabled }
            />
          </Col>
        </Row>

        {!!disabled && 
          <Row className="margin-top">
            <Col>
              <div className="alert-warning">
                Si deseas editar el RFC es necesario desactivar todas las integraciones del SAT.
              </div>
            </Col>
          </Row>
        }

        <Row style={{marginTop:25}}>
          <Col style={{paddingLeft:0, display:"flex", justifyContent:"flex-end"}}>
            <Button color="success">CONTINUAR</Button>
          </Col>
        </Row>
      </form>
    </div>
  )
}

FormSatRfc.propTypes = {
  initialize: PropTypes.func.isRequired,
  setGlobalRfc: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const validate = values => {
  const { sat_rfc } = values, errors = {};

  if (!sat_rfc) errors.sat_rfc = 'Ingresa un RFC valido'
  else if(!validateRfc(sat_rfc)) errors.sat_rfc = 'El RFC no es válido'

  return errors;

}; // END validate

export default reduxForm({ form: 'VALIDATE_RFC', validate })(connect(state => ({
  errors             : get(state, 'errors'),
	form               : get(state, 'form.VALIDATE_RFC.values'),
  integrations       : get(state, 'integrations'),
  rfc                : get(state, 'account.profile.tax_profile'),
	enableReinitialize : true

}) , { promptUser })(FormSatRfc)); // END connect export



// WEBPACK FOOTER //
// ./src/containers/account/components/satIntegration/FormSatRfc.js